<template>
    <treeNode :treeData="tree"></treeNode>
</template>

<script>
import treeNode from './treeOne.vue';

export default {
  props: ["medicalTree"],
  components: {
    treeNode
  },
  data() {
    return {
      medicalTree:[],
      tree: []
    }
  },
  watch: {
    medicalTree: {
      handler(newValue, oldValue) {
        this.tree = newValue
      },
    },
  },
  created() {
    
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>
<style lang='less' scoped>
.block {
  margin-top: -30px;
}
</style>